import React from "react";

import { Typography } from "@mui/material";

export const SudsLongDescription = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Limitations of the data:
        <ul>
          <li>
            It cannot be guaranteed that all SuDS schemes were captured during
            the initial data collection process.
          </li>
          <li>
            The data quality varies greatly throughout the dataset. For example,
            in some areas each rain garden on a street is a separate point,
            whereas in another area, all rain gardens on a street are under one
            single point.
          </li>
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        How will the map be kept up to date?
        <ul>
          <li>
            There is an editable version of the map that will be sent to Borough
            officers and other stakeholders that delivery SuDS in London.
          </li>
          <li>
            They will be encouraged to add points to the map when a SuDS scheme
            is complete.
          </li>
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        Please contact{" "}
        <a href="mailto:holly.smith@london.gov.uk">holly.smith@london.gov.uk</a>{" "}
        for more information.
      </Typography>
    </>
  );
};

export const sudsShortDescription =
  "Click a Sustainable Drainage System on the map to view more information.";
